const netherlands = [
    { "code": "DR", "name": "Drenthe" },
    { "code": "FL", "name": "Flevoland" },
    { "code": "FR", "name": "Friesland" },
    { "code": "GE", "name": "Gelderland" },
    { "code": "GR", "name": "Groningen" },
    { "code": "LI", "name": "Limburg" },
    { "code": "NB", "name": "North Brabant" },
    { "code": "NH", "name": "North Holland" },
    { "code": "OV", "name": "Overijssel" },
    { "code": "ZH", "name": "South Holland" },
    { "code": "UT", "name": "Utrecht" },
    { "code": "ZE", "name": "Zeeland" }
  ]
  
export default netherlands;